import React, { useState, useEffect } from 'react';
import styles from './HeroSection.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSeedling,
    faObjectGroup,
    faArrowRight,
    faDownload,
    faCity
} from '@fortawesome/free-solid-svg-icons';

import ribbonImg from '../../assets/everett.png';
import CTAPopup from '../../components/CTAPopup/CTAPopup';
import logo from '../../assets/the-everett-logo-3.png';
import img1 from '../../assets/hero1.jpeg';
import img2 from '../../assets/hero2.jpeg';
import img3 from '../../assets/hero3.jpeg';
import { notifyHeroEnquiry } from '../../lib/whatsapp/sendWhatsApp';

const images = [img1, img2, img3];

const HeroSection = () => {
    const [current, setCurrent] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [form, setForm] = useState({ name: '', phone: '', email: '' });
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrent((prev) => (prev + 1) % images.length);
        }, 5000);
        return () => clearInterval(timer);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            await notifyHeroEnquiry({
                name: form.name,
                phone: form.phone,
                email: form.email,
            });
            setSubmitted(true);
        } catch (err) {
            console.error('WhatsApp notification failed:', err);
            setError('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.wrapper}>
            <section className={styles.hero}>

                {/* ── LEFT: Full-bleed Carousel ── */}
                <div className={styles.carousel}>
                    {images.map((img, i) => (
                        <img
                            key={i}
                            src={img}
                            alt={`Building view ${i + 1}`}
                            className={`${styles.slide} ${i === current ? styles.active : ''}`}
                        />
                    ))}

                    <div className={styles.overlay} />

                    {/* Ribbon */}
                    {/* <div className={styles.ribbon}>
                        <img
                            src={ribbonImg}
                            alt="Ribbon"
                            className={styles.ribbonImage}
                        />
                    </div> */}

                    {/* Text content over image */}
                    <div className={styles.imageContent}>
                        <div className={styles.goldLine}></div>
                        <h2 className={styles.tagline}>
                            The Trump Standard.<br />
                            <em>Now in Pune.</em>
                        </h2>
                        <p className={styles.taglineDesc}>An address that defines legacy.</p>

                        <div className={styles.imageStats}>
                            <div className={styles.imageStat}>
                                <FontAwesomeIcon icon={faSeedling} className={styles.imageStatIcon} />
                                <div className={styles.imageStatText}>
                                    <span className={styles.imageStatValue}>3.6</span>
                                    <span className={styles.imageStatLabel}>Acres Approx</span>
                                </div>
                            </div>
                            <div className={styles.imageStat}>
                                <FontAwesomeIcon icon={faCity} className={styles.imageStatIcon} />
                                <div className={styles.imageStatText}>
                                    <span className={styles.imageStatValue}>2</span>
                                    <span className={styles.imageStatLabel}>Towers</span>
                                </div>
                            </div>
                            <div className={styles.imageStat}>
                                <FontAwesomeIcon icon={faObjectGroup} className={styles.imageStatIcon} />
                                <div className={styles.imageStatText}>
                                    <span className={styles.imageStatValue}>3, 4 & 5</span>
                                    <span className={styles.imageStatLabel}>BHK Residences</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── RIGHT: Floating Card ── */}
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <img
                            src={logo}
                            alt="Tribeca Logo"
                            className={styles.cardLogo}
                        />
                        <p className={styles.location}>
                            <span className={styles.locDash}>—</span> AT LULLANAGAR <span className={styles.locDash}>—</span>
                        </p>
                    </div>

                    {/* Pricing */}
                    <div className={styles.pricing}>
                        <p className={styles.pricingLabel}>STARTING PRICE</p>
                        <p className={styles.pricingConfig}>3BHK, 4BHK & 5BHK</p>
                        <p className={styles.pricingAmount}>
                            ₹3.75 Cr* <span className={styles.pricingOnwards}>ONWARDS</span>
                        </p>
                    </div>

                    <div className={styles.divider} />

                    {/* Form */}
                    {submitted ? (
                        <div className={styles.successBox}>
                            <p className={styles.successTitle}>✓ Thank You!</p>
                            <p className={styles.successText}>Our team will reach out to you shortly.</p>
                        </div>
                    ) : (
                        <form className={styles.form} onSubmit={handleSubmit}>
                            <p className={styles.formTitle}>ENQUIRE TO KNOW MORE</p>
                            <div className={styles.formRow}>
                                <input
                                    className={styles.input}
                                    type="text"
                                    name="name"
                                    placeholder="Name*"
                                    value={form.name}
                                    onChange={handleChange}
                                    required
                                />
                                <input
                                    className={styles.input}
                                    type="tel"
                                    name="phone"
                                    placeholder="Mobile*"
                                    value={form.phone}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <input
                                className={styles.input}
                                type="email"
                                name="email"
                                placeholder="Email (Optional)"
                                value={form.email}
                                onChange={handleChange}
                            />
                            <label className={styles.consent}>
                                <input type="checkbox" defaultChecked className={styles.checkbox} />
                                <span>
                                    I consent to the processing of provided data according to{' '}
                                    <a href="#privacy">Privacy Policy</a> &amp; <a href="#terms">Terms &amp; Conditions</a>
                                </span>
                            </label>

                            {error && <p className={styles.errorText}>{error}</p>}

                            <button className={styles.enquireBtn} type="submit" disabled={loading}>
                                {loading ? 'SENDING...' : 'ENQUIRE NOW'}
                                {!loading && <FontAwesomeIcon icon={faArrowRight} />}
                            </button>
                            <button
                                className={styles.brochureBtn}
                                type="button"
                                onClick={() => setPopupOpen(true)}
                            >
                                DOWNLOAD BROCHURE
                                <FontAwesomeIcon icon={faDownload} />
                            </button>
                        </form>
                    )}
                </div>

            </section>

            <CTAPopup
                isOpen={popupOpen}
                onClose={() => setPopupOpen(false)}
                title="Download Brochure"
            />
        </div>
    );
};

export default HeroSection;